// WBESC Address
const WBESC_ADDRESS = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'

export { WBESC_ADDRESS }
